var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  userName: function userName(state) {
    return state.user.userName;
  },
  nickName: function nickName(state) {
    return state.user.nickName;
  },
  user: function user(state) {
    return state.user;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permisaction: function permisaction(state) {
    return state.user.permisaction;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  selectOpts: function selectOpts(state) {
    return state.global.selectOpts;
  },
  wsData: function wsData(state) {
    return state.ws.data;
  },
  apiurl: function apiurl(state) {
    return state.apiurl.apiurl;
  },
  apiurl2: function apiurl2(state) {
    return state.apiurl2.apiurl;
  },
  menuIds: function menuIds(state) {
    return state.area.menuIds;
  } // 新添加
};

export default getters;